.EmptyStateBanner {
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 331px;

  .Icon svg {
    fill: none;
    height: 85px;
    width: 167px;
  }

  .Title {
    display: inline-block;
    font-size: 22px;
    line-height: 32px;
    margin-top: 32px;
  }

  .BodyText {
    margin-top: 16px;
    font-size: 16px;
    line-height: 24px;
  }
}
